import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';
import FaqBlock from '../../components/FaqBlock';
import { TextBox } from '../../components/privatleasing/TextBox';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import Snippet from '../../components/Snippet';
import BulletIcon from '../../components/ui/BulletIcon';
import KIAImage from '../../components/ui/image/KIAImage';
import LinkButton from '../../components/ui/LinkButton';
import TextOnImg from '../../components/ui/TextonImg';
import {
  applicationSection,
  climatePremiumIntro,
  faqBlockPL,
  heroCBPV5,
  img001,
  linkCB01,
  smallImg001,
  smallImg002,
  text001,
  text002,
  textBoxCB,
} from './climateBounusPVFive-copy';

const ClimateBounusPVFive = () => {
  return (
    <main className="relative max-w-screen-kia mx-auto">
      <TextOnImg {...heroCBPV5} />

      <div className="w-full mx-auto">
        <section>
          <m.div
            initial="hidden"
            whileInView="visible"
            variants={containerVariants}
            viewport={viewPort}
            className="mb-16 mx-auto max-w-screen-kia-sm object-fill"
          >
            <m.p
              variants={itemVariants}
              className=" text-center font-light text-[18px] px-2 mt-[28px]"
            >
              {text001}
            </m.p>
          </m.div>
        </section>
        <section className=" mx-auto px-6 w-full  max-w-7xl mb-7">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4 "
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={
              <div>
                <h3 className={climatePremiumIntro.titleClass}>
                  {climatePremiumIntro.title}
                </h3>
                <p className={climatePremiumIntro.textClass}>
                  {climatePremiumIntro.text}
                </p>
                <ul className={climatePremiumIntro.listClass}>
                  {climatePremiumIntro.listItems.map((item, i) => (
                    <li key={i} className="flex items-start space-x-2">
                      <BulletIcon className="w-[6px] h-[6px] mt-[7px] flex-shrink-0" />
                      <span className="text-base font-[300] leading-[1.3]">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            }
            secondComponent={<KIAImage {...smallImg001} />}
          />
        </section>
        <section className=" mx-auto px-6 w-full  max-w-7xl mb-10">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4 "
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0 "
            secondComponentClassName="p-0 lg:p-10 lg:pt-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...smallImg002} />}
            secondComponent={
              <div>
                <h3 className={applicationSection.titleClass}>
                  {applicationSection.title}
                </h3>
                <div className="mb-6">
                  {applicationSection.paragraphs.map((p, i) => (
                    <p
                      key={i}
                      className="mb-1 text-base leading-[1.3] font-[300]"
                    >
                      {p}
                    </p>
                  ))}
                </div>
                <h3 className={applicationSection.secondTitleClass}>
                  {applicationSection.secondTitle}
                </h3>
                <ol className={applicationSection.stepsListClass}>
                  {applicationSection.steps.map((step, i) => (
                    <li
                      key={i}
                      className="!list-item"
                      dangerouslySetInnerHTML={{ __html: step }}
                    />
                  ))}
                </ol>
                <p className={applicationSection.footerTextClass}>
                  {applicationSection.footerText}
                </p>
              </div>
            }
          />
        </section>

        <TextOnImg {...img001} />

        <section>
          <m.div
            initial="hidden"
            whileInView="visible"
            variants={containerVariants}
            viewport={viewPort}
            className="mx-auto max-w-[700px] mt-[28px]"
          >
            <m.p
              variants={itemVariants}
              className="text-center font-light text-[20px] px-2  whitespace-pre-line break-normal hyphens-none  leading-[1.2]"
            >
              {text002}
            </m.p>
          </m.div>
          <TextBox {...textBoxCB} mtClass="mt-[33px]" mbClass="mb-1" />
        </section>

        <article className="bg-#fff max-w-screen-kia-sm mx-auto ">
          <FaqBlock {...faqBlockPL} titleAlign="left" />
          <div className="flex justify-center sm:justify-start">
            <LinkButton {...linkCB01} />
          </div>
        </article>

        <Snippet page="climate-bounus-pv5" />
      </div>
    </main>
  );
};

export default ClimateBounusPVFive;
